import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
// import { of } from 'rxjs/internal/observable/of';
// import { catchError } from 'rxjs/internal/operators/catchError';
import { map } from 'rxjs/internal/operators/map';
import { mergeMap } from 'rxjs/internal/operators/mergeMap';
import { PetitionerService } from 'src/app/services/petitioner.service';
import * as frmStepStatusUpdateAction from '../actions/step-status-update.actions';

@Injectable()
export class StepStatusUpdateEffects {

  constructor(private actions$: Actions,
    private petitionerService: PetitionerService) { }

  subTaskDetailsEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(frmStepStatusUpdateAction.updatei140StepStatus),
      mergeMap((action) => this.petitionerService.updateStepStatus(action.payload, action.subTaskId, action.actionCode).pipe(
        map((stepStatusResponse) => ({ type: '[i140StepStatusUpdate] Update StepStatusUpdates Success', response: stepStatusResponse })),
        //catchError((error) => of({ type: '[i140StepStatusUpdate] Update StepStatusUpdates Failure', response: error }))
      )));
  });

}
